var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: "查看",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, "label-width": "110px" }
        },
        _vm._l(_vm.form.params, function(item, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("div", { staticClass: "langTitle" }, [
                _vm._v(" " + _vm._s(item.languageName) + " ")
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "游戏名称",
                    prop: "params." + index + ".game_name"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入游戏名称" },
                    model: {
                      value: item.game_name,
                      callback: function($$v) {
                        _vm.$set(item, "game_name", $$v)
                      },
                      expression: "item.game_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "图标", prop: "params." + index + ".icon" }
                },
                [
                  _c("uploadImage", {
                    attrs: { disabled: true, value: item.picfileList },
                    on: {
                      input: function($event) {
                        return _vm.imgChange($event, item, index)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }